import React from 'react';
import './InstitutionSelection.css';
import AuthLoader from './AuthLoader';
import { URL } from '../variables';

class SelectFaculdade extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      faculdades: [],
      faculdade_select: 'tete',
      loading: false,
      msgErro: '',
      redirect: false
    }
  }

  change_faculdade(event) {
    this.setState({ faculdade_select: event.target.value });

  }

  // renderRedirect = () => {
  //   if (this.state.redirect) {
  //     return <Redirect to={'/'+this.state.faculdade_select.slug} />
  //   }
  // }

  get_faculdades() {
    fetch(`${URL}api/avaliador/get_faculdades`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',

        // 'Authorization': `Bearer ${this.props.token}`,
        // 'Content-Type': 'application/json',
      }
    }).then(async (responseLog) => {
      try {
        let resp = await responseLog.json();
        console.log(resp);
        if (resp.errors != null || resp.error != null) {
          let errors = Object.values(resp.errors);
          let erro = '';
          for (let i = 0; i < errors.length; i++) {
            if (i != errors.length - 1)
              erro += errors[i] + '\n';
            else
              erro += errors[i];
          }
          console.log(erro);

          this.setState({ loading: false, msgErro: erro, refresh: false, loadingMore: false });
        }
        else {
          let selected = '';
          if (resp.faculdades.length > 0) {

            selected = resp.faculdades[0].slug;
          }
          this.setState({ faculdades: resp.faculdades, loading: false, msgErro: '', faculdade_select: selected });
          // this.setState({ loading: false, refresh: false, loadingMore: false, msgErro: '' });

        }




      } catch (err) {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor', refresh: false, loadingMore: false });

      }

    })
      .catch((err) => {
        console.log(err);
        this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?', refresh: false, loadingMore: false });
      });
  }

  componentDidMount() {
    this.setState({ loading: true, msgErro: '' });
    this.get_faculdades();
  }






  render() {
    console.log(this.state.faculdade_select)
    return (
      <div className="evaluator-auth-page">
        {this.state.loading && <AuthLoader fullScreen title={"Carregando dados. Por favor, aguarde."} description={"Aguarde enquanto preparamos seu ambiente."} />}
        {this.state.loading == false && <div id="app" className="evaluator-select-page">
          <header className="evaluator-select-header">
            <a className="logo"><img src={require('../assets/images/logo-ontest.png')} height="58" alt="logo" /></a>
          </header>

          <main className="evaluator-select-main">
            <section className="evaluator-select-card">
              <div className="evaluator-select-copy">
                <span>{"Provas orais"}</span>
                <h1>{"Escolha o processo que você vai avaliar"}</h1>
                <p>{"Selecione a instituição ou processo seletivo para acessar o ambiente de avaliação da prova oral."}</p>
              </div>

              {this.state.msgErro && <div className="alert alert-danger" role="alert">{this.state.msgErro}</div>}
              <div className="evaluator-select-list">
                {this.state.faculdades.map((item, id) => (
                  <a key={item.id || item.slug} href={'/' + item.slug + '/login'} className="evaluator-select-item">
                    <div className="evaluator-select-logo">
                      <img src={item.logo || require('../assets/images/logo-ontest.png')} alt={item.name} />
                    </div>
                    <div className="evaluator-select-info">
                      <strong>{item.name}</strong>
                      <span>{"Acessar sala de avaliação"}</span>
                    </div>
                    <div className="evaluator-select-action">
                      <span>{"Acessar"}</span>
                      <i className="mdi mdi-arrow-right"></i>
                    </div>
                  </a>
                ))}
                {this.state.faculdades.length == 0 && <div className="evaluator-select-empty">
                  <i className="mdi mdi-clipboard-alert-outline"></i>
                  <p>{"Nenhum processo disponível no momento."}</p>
                </div>
                }
              </div>
            </section>
          </main>
        </div>}
      </div>
    );
  }


}

export default SelectFaculdade;
